import { getLink } from '../../../../utils/utils';
import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
        <p class="mb-3">
            Ехала наудачу, никого и ничего не зная. 
            Словарный запас-то у меня, разумеется, был – но только пассивный. 
            Я много читала (журналы, который давал мне Учитель), но говорить не говорила и не очень понимала долгую связную речь.
        </p>
        
        <p class="mb-3">
            Чтоб не было страшно, взяла с собой двух девочек-однокурсниц, 
            вообще ничего не слышавших и не знавших об эсперанто, - но разве это важно? 
            Мы просто едем в летний лагерь, в Прибалтику, где ещё не были – вот это интересно!
        </p>
        
        <p class="mb-3">
            Первое, что увидели по прибытии – объятия и поцелуи тех, кто снова встретился здесь после прошлого лагеря. 
            Как ни странно, это не умилило меня (мол, вот какая дружба завязывается здесь), 
            а наоборот, оттолкнуло: мы попадаем в закрытую группу, где все знают друг друга, 
            все тесно связаны – а мы чужие, здесь на нас никто не обращает внимания, мы никому не нужны. 
        </p>
        
        <p class="mb-3">
            И хотя сразу же мы познакомились с хорошим мальчиком из Латвии, 
            нашли общие интересы и как-то разобрались в окружающей жизни, но чувство отъединённости не проходило. 
            Вокруг кипела жизнь, люди бегали на какие-то заседания, конференции, семинары – всё, 
            разумеется, на свежем воздухе, под высокими балтийскими соснами, на толстой подстилке из опавших игл, 
            разогретых солнцем, запах которых я помню до сих пор. 
            Вот этот запах, наслаждение чужой природой, 
            наблюдение чужой активной жизни – воспоминания первых трёх дней. 
        </p>
        
        <p class="mb-3">
            Когда ощущение новизны прошло, эта отъединённость стала невыносимой: 
            я начала принципиально громко говорить по-русски (в лагере, являвшемся, по сути, 
            лагерем «языкового погружения», вся жизнь проходила только на языке эсперанто, 
            и использование любого родного языка было запрещено правилами и просто высмеивалось окружающими). 
            Ничто не действует так оскорбительно на юного человека, как насмешка. 
            За что смеяться надо мной, если я училась читать и писать, а не говорить, 
            и ничего не знала о принципах организации молодёжного движения, т.к. 
            мне это было  совершенно не интересно? 
            Я чувствовала себя чужой; сообщество отвергало меня 
            (т.е. было закрыто в себе и не стремилось привлечь новых членов). 
            Тогда и я обозлилась на всё вокруг и решила, что здесь мне не место, и скорей бы это всё кончилось, 
            и ноги моей в этом эсперанто больше не будет…
        </p>
        
        <p class="mb-3">
            А на четвёртый день случилось Чудо.
        </p>
        
        <p class="mb-3">
            Меня заметил один старый эсперантист, 
            который часто приезжал в Одессу и запомнил меня как «лучшую ученицу» нашего школьного кружка. 
            Он узнал меня, заговорил со мной. 
            Его (как оказалось, и многих других) интересовала эсперанто-жизнь в Одессе, 
            которая была тогда представлена только в клубе стариков; 
            поэтому привлекло внимание появление именно молодого человека из Одессы. 
            Как известно, Одесса была «колыбелью Эсперанто-движения»: первый эсперанто-клуб был здесь основан в 1894-96 гг.; 
            многие выдающиеся деятели эсперанто-движения были родом из Одессы: например, В. А. Гернет в 1895-97 гг., 
            живя в Одессе, спонсировал и редактировал издающийся в Швеции единственный на то время эсперантский журнал «Международный язык», и т.д., и т.д…. 
            За более чем сотню прошедших лет возникало и распадалось много клубов; но история эсперанто-движения в Одессе, пусть с перерывами, но продолжалась. 
            И вот, на смену очередному состарившемуся клубу, появился новый, молодой человек, который, возможно, продолжит это движение. 

        </p>
        
        <p class="mb-3">
            Не удивительно, что мною заинтересовались. 
            Меня представили тогдашнему президенту SEJM – Sovetunia Esperantista Junulara Movado 
            (Молодёжного движения Эсперантистов Советского Союза), который тоже оказался одесситом (точнее, здесь он выучил эсперанто!). 
            И я попала в круговорот событий.
        </p>
        
        <p class="mb-3">
            «Меня призвали всеблагие Как собеседника на пир». 
            С тех пор все мои дни проходили в компании интереснейших людей, которые были идейным и организационным центром лагеря. 
            Я бы не сказала, что они уделяли мне особое внимание; просто они впустили меня в свой круг, т.е. 
            разбилась та замкнутая стена, что отделяла меня от сплочённой группы единомышленников. 
            Они разрешали мне ходить с ними на все конференции, обсуждения и семинары – и мне уже было интересно, 
            потому что я видела, что этим занимаются хорошие и умные люди. 
            Я стала прислушиваться – и оказалось, что понимаю почти всё, о чём говорилось. 
            Пассивный запас слов перешёл в активный, и я начала говорить… Если я не знала какого-то слова, 
            то просто называла его по-русски, вставляя в эсперантскую речь, и мне тут же сообщали перевод этого слова, и я старалась запомнить. 
            Это были дни очень интенсивной умственной деятельности – и в сфере овладения языком, и просто узнавания и понимания множества новых вещей. 
            Здесь я впервые узнала об организации самостоятельной творческой работы молодого поколения. 
            Мы всё придумывали и выполняли сами; это был оазис в среде приказов и указаний; это была свобода творческой жизни. 
            И это давало ощущение полного, ослепительного счастья. 
            Там начались лучшие дни моей жизни.
        </p>
        
        <p class="mb-3">
            Активная умственная деятельность сказывалась во всём: к середине лагеря я уже думала и видела сны на эсперанто; 
            а вернувшись домой, я, за неимением собеседников (мой Учитель уже год как умер, и кружковцы разбежались), 
            - за неимением собеседников я говорила на эсперанто со своей собачкой. 
            Она понимала меня…
        </p>



        <p class="mb-3">
            Я ко второму моему лагерю была уже опытной эсперантисткой, получала нашу внутреннюю газету, была в курсе событий и, 
            конечно, с нетерпением ожидала очередного летнего лагеря. 
            Но почему-то сообщений о нём не было… И вдруг я получаю письмо от хорошего мальчика, 
            с которым познакомилась в одном из прошлых лагерей, но никогда не переписывалась. 
            В письме был только адрес, куда следовало обратиться, и больше ничего. 
            Так как времени оставалось совсем мало, я едва успела купить билет на самолёт и вылететь в Ленинград, практически в неизвестность. 
            Лагерь был не в Ленинграде, а под Тихвином, почти в 300 километрах от города, палаточный, на берегу реки.
        </p>
        
        <p class="mb-3">
            Так как я приехала без палатки, меня поселили в большую 10-местную палатку, где жил известный эсперантист Владимир Самодай 
            (тоже, кстати, одессит!) со своим 11-летним сыном. 
            Они занимали один угол палатки; я бросила свои вещи в другом и побежала вживаться в обстановку: встречаться с друзьями, 
            узнавать программу и места кормёжки (было несколько отрядов, и у каждого свой костёр, комплект котлов и т.п.).
        </p>
        
        <p class="mb-3">
            Но вот наступила ночь…
        </p>
        
        <p class="mb-3">
            У нас в Одессе август – обычно самый жаркий месяц лета. 
            Море, как резервуар, за жаркие месяцы набирает тепло, и затем отдаёт его, постепенно охлаждаясь и становясь затем резервуаром холода. 
            Поэтому у нас холодная и дождливая весна, а в августе и сентябре сухо и жарко. 
            И я, как ещё неопытный турист, в летний августовский лагерь взяла какие-то сарафаны, шёлковые платья, и всего одну куртку-ветровку. 
            А вместо рекомендованного спальника легкомысленно прихватила тоненькое одеяльце, на всякий случай. 

        </p>
        
        <p class="mb-3">
            И вот наступила суровая северная августовская ночь… Матрасов в палатках не было предусмотрено (сказали же, берите спальники!), 
            и я пыталась уснуть на голом полу, укутавшись в своё одеяльце. 
            В другом углу Самодаи спали, завернувшись в настоящую меховую шкуру, наверное, медвежью. 
            Как я им позавидовала!
        </p>
        
        <p class="mb-3">
            Но холод пробирал до костей, уснуть было невозможно, и я выползла из палатки и пошла искать спасения. 
            Спасение нашлось в виде небольшого костра на берегу реки, где грелось несколько таких же несчастных, не имевших тёплых вещей. 
            Сначала нас было 4 человека: двое совсем молодых мальчиков, я и Наташа Кириллова, приехавшая в свой первый лагерь. 
            Она пела и играла на гитаре всю ночь, мы слушали, и ночь прошла незаметно. 

        </p>
        
        <p class="mb-3">
            А днём можно было отоспаться в чужой палатке, где проходило очередное мероприятие: в отличие от Прибалтики, 
            где всё происходило большей частью на воздухе, под солнцем – в Тихвине днём солнца не было, обычно шёл дождь, и мы забирались в палатки. 
            Даже в большой палатке, если в ней много людей, становится теплее. 
            Утром объявлялось, в какой палатке что будет происходить, и туда набивалась куча народа, кроме «местных жителей». 
            Оказалось, что довольно много народу не спало ночью и отсыпалось днём 😀, и это социальное явление даже получило своё имя: 
            таких спящих днём во время общих мероприятий называли kadavretoj (трупики). 
            С этим явлением связано одно из самых приятных моих воспоминаний о Тихвине.
        </p>
        
        <p class="mb-3">
            Однажды я, как обычно, заснула в чьей-то палатке; в свою, пустую и ледяную, я вообще почти не заходила. 
            Вдруг объявляют, что в этой палатке состоится конкурс синхронных переводчиков на эсперанто, 
            и «кадавретов» весьма бесцеремонно попросили убраться и освободить место для нужных и ценных людей – участников конкурса. 
            Я, во-первых, не хотела выходить на холодную и мокрую улицу; а во-вторых, я просто возмутилась таким отношением, 
            и решила доказать, что я тоже нужная и ценная… 
            Короче, я воспряла ото сна и заявила, что я не «кадаврето», а хочу быть участником конкурса. 
            Пожав плечами, меня записали.
        </p>
        
        <p class="mb-3">
            Я разозлилась, и под влиянием эмоций, как храбрый портняжка… 
            Вот сейчас не помню, 2-ое или 3-е место я заняла (среди весьма опытных эсперантистов), 
            но на следующий день на общем собрании меня торжественно поздравили и вручили приз – книгу В. Олда «Шаги к полному овладению эсперанто». 
            Эта книга – учебник для совершенствующихся в языке – очень помогла мне «полнее овладеть эсперанто». 
            Но ещё важнее было признание. 
            И я в себе, и другие во мне впервые увидели не просто девочку, получающую удовольствие в приятной среде, но и возможного серьёзного деятеля. 
            Во всяком случае, я после этого обрела уверенность в себе, что очень важно для молодого человека. 
            Я начала переводить стихи, писать рассказы…
        </p>
        
        <p class="mb-3">
            Но пока продолжалась лагерная жизнь. 
            На моё счастье, дожди шли только днём, а ночи были звёздные и сухие. 
            Наладился распорядок дня: ночь у костра, днём несколько часов сна в чужих палатках, и снова – семинары, обсуждения, доклады… 
            А если днём случайно не было дождя, мы по нескольку часов без остановки играли в бадминтон: согреться!! 
            Моим партнёром обычно был Валера Бондарь, очень талантливый, но очень давно ушедший из эсперанто.
        </p>
        
        <p class="mb-3">
            А костёр наш и поющая Наташа с каждым днём привлекали всё больше людей; если в первый день нас было четверо 
            (да ещё где-то рядом, временами подползая к костру, спал Виктор Чалдаев), 
            - то к концу смены у костра ночевало уже больше половины населения лагеря. 
            Наташа пела…
        </p>
        
        <p class="mb-3">
            В последующей истории SEJM’a и SEJT’ов она известна как Наташа Берце. 
        </p>



        <p class="mb-3">
            Всё – ново, ярко, интересно!
        </p>
        
        <p class="mb-3">
            Планируя такое далёкое и экзотическое путешествие, мы выбрали длинный и экзотический маршрут: 
            морем на круизном корабле до Сочи, оттуда по железной дороге до Армении. 
            И само путешествие было волшебным. 
            На корабле мы загорали в шезлонгах, купались в бассейне, ходили в кино и на танцы; 
            и три раза в день нас приглашали в ресторан, где в просторном салоне на белоснежных скатертях сверкали бокалы и столовые приборы. 
            Конечно, закопчённые кружки и котлы хороши в походных условиях; но время от времени хочется и чистоты, и комфорта, и внимательного обслуживания. 

        </p>
        
        <p class="mb-3">
            А какие экскурсии у нас были! Напомню: это был круиз по знаменитой Крымско-Кавказской линии, 
            которым хоть раз в жизни наверняка воспользовался каждый одессит. 
            Комфортабельные суда ходили по  маршруту Одесса – Батуми – Одесса и могли использоваться просто как транспорт: 
            так, мы купили билеты только до Сочи, и в любом порту захода можно было сойти или, по желанию, 
            продолжить путь на другом судне той же линии, пожив немного в курортных городах Ялта, Сочи, Сухуми, 
            или же осмотрев города-герои Севастополь и Новороссийск. 
            Для тех же, кто продолжал путь, в каждом порту устраивались многочасовые стоянки, 
            во время которых туристов отвозили на экскурсии по городу. 
            В Севастополе мы посетили диораму Обороны Севастополя в 1854 году и Малахов курган; 
            в Ялте гуляли по восхитительной набережной, поднимались к Армянской церкви; 
            в Новороссийске прошлись по набережной имени адмирала Серебрякова, где много интересных памятников, 
            в том числе памятник основателям Новороссийска, стела Морской славы. 

        </p>
        
        <p class="mb-3">
            В общем, само начало путешествия уже было полно самых чудесных впечатлений. 
            А сколько их ещё было впереди!
        </p>
        
        <p class="mb-3">
            В Сочи мы сошли с корабля и на несколько дней остановились у эсперантистки Галины Беленюк. 
            С ней мы были в замечательном ботаническом саду – Сочинском дендрарии, посетили парк «Ривьера», 
            знаменитую Ротонду; а спали мы в большом гамаке у неё на балконе, т.к. 
            в комнате было жарко; и вообще, мы же за экзотикой ехали!
        </p>
        
        <p class="mb-3">
            А дальше ехать было ещё интересней! 
            По нашей просьбе, Галина купила нам билеты на поезд до Еревана; но, т.к. 
            билетов в летнее время из курортных городов обычно не бывает, нам взяли билеты со следующей за Сочи станции, 
            а до неё посоветовали «договориться» с проводником. 
            Но не мы одни договорились! 
            Когда мы вошли в наше купе, там уже сидела армянская семья из 5 человек! 
            Проводник стал нам объяснять, что эти места заняты, т.к. 
            на следующей станции сядут ещё 3 человека. 
            Наши уверения, что мы и есть эти трое, ни к чему не привели: так и ехали мы до конца в двойном составе. 
            Но окна были открыты, армяне поделились с нами своей очень вкусной крестьянской едой, 
            а главное – то, что было за окнами, поглотило всё наше внимание. 
            А за окнами была Турция и государственная граница. 
            В те времена (1984 г.) я и подумать не могла, что когда-нибудь смогу выехать за пределы СССР. 
            Честно говоря, и внутри страны я не во всех республиках бывала, не всё повидала; 
            но тогда потрясала сама возможность увидеть чужую землю, чужую страну. 
            А поезд несколько часов шёл вдоль самой границы. 
            Там – те же выжженные красные и охристые холмы, вдали – отара овец. 
            Но – граница! Но – Турция, первая увиденная чужая страна! 
            Несколько часов я не отрывалась от окна. 

        </p>
        
        <p class="mb-3">
            И такой же экзотикой встретил нас Ереван и замечательный Ереванский клуб. 
            Вообще, у одесских эсперантистов завязались особенно тёплые отношения с эсперантистами из Еревана, 
            и продолжались они ещё очень долго после 1984 года.
        </p>



        <p class="mb-3">
            А какой SEJT был в Ереване! Мы жили на турбазе в ущелье между двумя горами. 
            Для жителя приморской степи было невероятно, что солнце видно только какую-то часть дня: 
            оно вставало за одной горой, и часов в 5 дня скрывалось за другой. 
            Но пока оно было над нами – палило нещадно. 
            Поэтому так радовались все, когда в один из дней в лагере праздновали Вардавар – армянский праздник, 
            когда положено было обливать друг друга водой. 
            Обливались щедро, с наслаждением; но не для всех это было приятно. 
            Так, мой шестилетний сын подбежал ко мне и с восторгом сообщил, что налил какому-то дяде воды в карман 
            (он ростом как раз достигал до кармана взрослого человека). 
            Был ли в восторге тот дядя, история умалчивает. 

        </p>
        
        <p class="mb-3">
            Кстати, в том лагере мой 6-летний сын подружился с красивым стройным 20-летним юношей, 
            и гордо рассказывал, что у него есть настоящий друг, который его защищает и рассказывает интересные сказки. 
            Друга звали Гарик Коколия, и это был его первый лагерь. 

        </p>
        
        <p class="mb-5">
            Ещё во время Вардавара запомнился канатоходец. 
            Прямо в лагере между двумя столбами натянули толстый канат, и приглашённый человек 
            (как я поняла, не артист, а представитель народного искусства) показывал такие чудеса, 
            что я не могла в них поверить, даже увидев собственными глазами. 
            Сначала он ходил по канату, потом бегал, танцевал, переворачивался, шёл спиной вперёд… 
            Затем он шёл, завязав глаза и надев на голову плотный балахон. 
            И самое потрясающее: под конец он привязал к ногам два каната, спустил их вниз и предложил, 
            чтобы дети повисли на этих канатах и как угодно качались и крутились, пока он будет идти! 
            Разумеется, мой сын и ещё один мальчик подцепились, и катались, и крутились … а он шёл! 
            Безо всякой страховки! 
            И благополучно дошёл до конца каната. 
            Я до сих пор помню своё восхищение его искусством.
        </p>



        <p class="mb-3">
            Также были изумительные экскурсии: в хранилище древних армянских рукописей Матенадаран; 
            в Эчмиадзин, резиденцию католикоса, главы армянской церкви; к древним храмам Гарни и Гегард; на озеро Севан…
        </p>
        
        <p class="mb-5">
            Красота природы, душевность и искренняя забота о нас организаторов, яркая талантливость армянского народа, 
            проявляющаяся в архитектуре, музыке, танцах, в изобразительном искусстве и в народных обычаях – всё это сделало Ереванский лагерь незабываемым. 
            Да, я не помню в нём каких-то чисто эсперантских событий. 
            Но саму возможность прикоснуться и узнать из первых рук историю и культуру другого народа дал нам именно эсперанто. 

        </p>



        <p class="mb-3">
            Лучшие дни нашей жизни…
        </p>
        
        <p class="mb-3">
            Совсем не случайно называется так книга. 
            Это в самом деле лучшие дни, освещённые лучом памяти, купающиеся в солнечном свете; 
            дни полного счастья, радости от общения и взаимопонимания с единомышленниками, открытости миру, который принимает тебя.
        </p>
        
        <p class="mb-3">
            Это не строгая графика, где главенствует линия, чётко ведущая последовательность событий от начала до конца. 
            Это живопись, импрессионизм, где из отдельных цветовых пятен в голове зрителя создаётся яркая и цельная картина тех эмоций, 
            которые хотел передать зрителю автор. 
            А импрессионизм всегда – о радости жизни.
        </p>
        
        <p class="mb-3">
            Эта книга состоит из разных цветовых пятен, созданных разными авторами и посвящённых разным периодам времени, которые они пережили в Эсперантиде.
        </p>
        
        <p class="mb-3">
            Страны Эсперантиды нет на карте. 
            В неё не летят самолёты, не идут поезда… Но хотя бы раз в году можно накинуть рюкзак и отправиться в ту воображаемую страну, 
            где все тебя понимают, где все люди равноценны и равно ценны.
        </p>
        
        <p class="mb-3">
            О такой стране мечтал доктор Заменгоф, когда в 1887 году он издал «Учебник международного языка». 
            И до него, и после него такие проекты создавались сотнями. 
            Был язык Сольресоль, где слова выражались сочетанием звуков или красок; были аналитические языки Лейбница и Декарта; 
            были современные попытки, от идо до клингона. 
            Но только один язык стал живым средством общения, на котором разговаривают, пишут стихи и прозу, 
            ставят пьесы и фильмы, объясняются в любви и воспитывают детей. 
            Этот язык – Эсперанто.
        </p>
        
        <p class="mb-3">
            Практически каждый день в мире происходит какое-то событие, связанное с Эсперанто: 
            встреча по интересам, природоведческая экскурсия, конференция, конгресс, лагерь отдыха, культурный фестиваль. 
            Об участии в таких событиях и рассказывают авторы нашей книги. 
            И из этих отдельных голосов складывается то многоголосие, которое позоляет нам представить воображаемую страну, куда мы стремимся в мечтах. 

        </p>
        
        <p class="mb-3">
            Нам  повезло. 
            Мы не только в мечтах, но и наяву могли жить в этой счастливой стране.
        </p>
        
        <p class="mb-3">
            Мы – эсперантисты.
        </p>
    </div>
    `
  )
}

const itemName = {
  rus: `О начале эсперантской жизни`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;